import { useEffect, useRef, useState } from "react";
import { GlobalWorkerOptions, getDocument } from "pdfjs-dist";

// PDF.js worker 설정
GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

export default function PdfPreview({ fileUrl }) {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!fileUrl) return;

    async function loadPdf() {
      setLoading(true);
      const container = containerRef.current;
      container.innerHTML = ""; // 기존 canvas 초기화

      try {
        // ⬅⬅⬅ PDF 파일을 직접 fetch해서 blob으로 받음 (여기가 핵심!)
        const res = await fetch(fileUrl);
        const blob = await res.blob();
        const arrayBuffer = await blob.arrayBuffer();

        // PDF.js 로딩
        const pdf = await getDocument({ data: arrayBuffer }).promise;

        // 각 페이지 렌더링
        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const viewport = page.getViewport({ scale: 1.3 });

          const canvas = document.createElement("canvas");
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          const ctx = canvas.getContext("2d");
          await page.render({ canvasContext: ctx, viewport }).promise;

          container.appendChild(canvas);
        }
      } catch (err) {
        console.error("PDF 로딩 실패:", err);
        container.innerHTML =
          "<p style='text-align:center;color:#999;'>PDF 로딩 실패</p>";
      } finally {
        setLoading(false);
      }
    }

    loadPdf();
  }, [fileUrl]);

  return (
    <div className="w-full h-[600px] overflow-auto bg-gray-100 border rounded p-4">
      {loading && <p className="text-center text-gray-500">PDF 불러오는 중...</p>}
      <div ref={containerRef} className="space-y-4" />
    </div>
  );
}
